import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const KIND = { proposal: ["la propuesta", "propuestas"], invoice: ["la factura", "facturas"], quote: ["la cotización", "cotizaciones"] };

export function OpenAlertsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const load = useCallback(() => { api.get("/open-alerts").then((r) => setData(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);
  const onOpen = (o) => {
    setOpen(o);
    if (o && data.unread) { api.post("/open-alerts/seen").then(() => setData((d) => ({ ...d, unread: 0 }))).catch(() => {}); }
  };
  return (
    <Popover open={open} onOpenChange={onOpen}>
      <PopoverTrigger className="relative rounded-full p-2 text-slate-600 transition-colors hover:bg-slate-100" aria-label="Avisos" data-testid="open-alerts-bell">
        <Bell className="h-5 w-5" />
        {data.unread > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-orange-500 px-1 text-[11px] font-bold text-white" data-testid="open-alerts-count">{data.unread}</span>}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-popover p-0" data-testid="open-alerts-panel">
        <p className="border-b px-4 py-3 text-sm font-semibold text-slate-900">Documentos abiertos por clientes</p>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 ? <p className="px-4 py-6 text-center text-sm text-slate-500" data-testid="open-alerts-empty">Aún no hay aperturas.</p>
            : data.items.map((i) => (
              <Link key={`${i.kind}-${i.id}`} to={`/${KIND[i.kind][1]}/${i.id}`} className={`block border-b px-4 py-3 text-sm transition-colors hover:bg-slate-50 ${i.unread ? "bg-blue-50/60" : ""}`} onClick={() => setOpen(false)} data-testid={`open-alert-${i.kind}-${i.id}`}>
                <p className="font-medium text-slate-900">{i.client_name} abrió {KIND[i.kind][0]} {i.number}</p>
                <p className="text-xs text-slate-500">{fmtDateTime(i.client_opened_at)}</p>
              </Link>
            ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
